module.exports = __webpack_public_path__ + "media/images/arvut-424c8ee7b615f78f70030496f954925a.jp2";